import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";
import { userForgetPassword } from "../../actions/login.action";
import { EMAIL_VALIDATE, EMAIL_VALIDATE_USERID } from "../../validation";
import { bindActionCreators } from "redux";
import connect from "react-redux/es/connect/connect";
import { LoaderPage } from "../../component/Loader";
import { toast } from "react-toastify";
import { get } from "lodash";
import ReCaptcha from "../GoogleCaptcha/googleCaptcha";
import { ERROR_MSG } from "../../constant";
import { successToastStyle, errorToastStyle } from "../../customToast";
import backButton from "../../assets/back-button.png";

class ForgetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailValid: [],
      captchaToken: null
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  validateField = (fieldName, value) => {
    let { emailValid } = this.state;
    emailValid = EMAIL_VALIDATE_USERID(value);
    this.setState({
      emailValid: emailValid
    });
  };

  validateForm = () => {
    let { emailValid } = this.state;
    if (emailValid.error !== undefined && !emailValid.error) {
      return true;
    }
    return false;
  };

  handleForgetPassword = async event => {
    //event.preventDefault();
    const { email, captchaToken } = this.state;
    const { handleForget } = this.props;
    this.validateField("email", email);
    let isValidData = this.validateForm();
    if (isValidData) {
      await this.props.userForgetPassword(undefined, {
        emailIdOrUserId: email,
        googleCaptchaToken: captchaToken
      });
      const { data } = this.props;
      // const status = data && data.status || false;
      if (data && data.status === true) {
        toast.success(
          <p className="toast-text-alignment">
            {"You should receive an email shortly with further instructions."}
          </p>,
          successToastStyle
        );
        // reset the state of forget password
        handleForget();
      } else {
        toast.error(
          <p className="toast-text-alignment">{get(data, "message")}</p>,
          errorToastStyle
        );
      }
    }
    this.captchaElement &&
      this.captchaElement.reset(this.captchaElementResetId);
  };

  onCaptchaResolved = captchaToken => {
    this.setState({ captchaToken });
    (captchaToken && this.handleForgetPassword()) ||
      toast.error(
        <p className="toast-text-alignment">{ERROR_MSG.INVALID_CAPTCHA}</p>,
        errorToastStyle
      );
  };

  onValidateCaptcha = e => {
    e.preventDefault();
    // this.validateField();
    // let isValidData = this.validateForm();
    if (this.captchaElement) {
      this.captchaElement.execute(this.captchaElementResetId);
    }
  };

  render() {
    const { email, emailValid } = this.state;
    const { loading, handleLoginWithPassword, handleForget } = this.props;
    return (
      <div className="register-inner">
        <LoaderPage loading={loading === "LOADING"} />
        <img
          src={backButton}
          alt="Back"
          className="back-btn"
          onClick={() => handleForget()}
        />
        <h1 className="page-heading hide-heading">Forgot Password</h1>
        <Form className="signin-form" onSubmit={this.onValidateCaptcha}>
          <div className="userId">
            <Form.Group>
              <Form.Label>Username or Email</Form.Label>
              <Form.Control
                name="email"
                type="text"
                value={email}
                onChange={this.handleChange}
                onBlur={() => this.validateField("email", email)}
                isInvalid={emailValid && emailValid.error}
              />
              <Form.Control.Feedback type="invalid">
                {emailValid.error ? emailValid.message : null}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
          <Button
            variant="primary"
            type="submit"
            className="btn-orange full-width"
          >
            Submit
          </Button>
        </Form>
        <div className="new-login-forgot-text">
          Enter your registered email address or username, and we will help you
          create a new password.
        </div>
        <ReCaptcha
          id="recaptcha-2"
          getRef={ref => {
            this.captchaElement = ref;
          }}
          onChange={this.onCaptchaResolved}
          resetId={id => {
            this.captchaElementResetId = id;
          }}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.loginReducer.forgetData,
    loading: state.loginReducer.forgetStatus
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      userForgetPassword: userForgetPassword
    },
    dispatch
  );
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ForgetForm)
);
